module.exports = __webpack_public_path__ + "static/media/thumbs-up.7966602e.svg";